export const DB_NODES = {
  ACTIVE: "active",
  ALBUMS: "albums",
  CATEGORIES: "categories",
  CITY_ID: "city_id",
  COLOR: "color",
  COUNTRY_ID: "country_id",
  DATE: "date",
  FROM: "from",
  FWC_2022: "FWC_2022",
  FWWC_2023: "FWWC_2023",
  GEO_AREA_CITIES: "geo_area_cities",
  GEO_AREA_COUNTRIES: "geo_area_countries",
  GEO_AREA_NEIGHBOURHOODS: "geo_area_neighbourhoods",
  GEO_AREA_STATES: "geo_area_states",
  MISSING: "missing",
  MOST_GRANULAR_GEO_AREA_ID: "most_granular_geo_area_id",
  NAME_L10N: "nameL10n",
  NAME: "name",
  NEIGHBOURHOOD_ID: "neighbourhood_id",
  NOTIFICATION_ID: "notificationId",
  // NOTIFICATIONS: "notifications",
  PHONE_NUMBER_SHARING: "phone_number_sharing",
  PHONE_NUMBER: "phoneNumber",
  PUSH_NOTIFICATION_TOKENS: "push_notification_tokens",
  READ: "read",
  REPEATED: "repeated",
  SHARED_WITH: "sharedWith",
  STATE_ID: "state_id",
  STICKERS: "stickers",
  TO: "to",
  TOKENS: "tokens",
  TYPE: "type",
  USER_ALBUMS: "user_albums",
  USER_BLOCKAGES: "userBlockages",
  USER_NOTIFICATIONS: "user_notifications",
  USERS: "users",
};
